module.exports = __webpack_public_path__ + "img/granada1.d59fcee9.jpg";